function afterDomSettles(callback) {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            window.setTimeout(callback, 0);
        });
    });
}

function stickyHeaderOffset() {
    const header = document.querySelector("header.sticky");

    return (header?.getBoundingClientRect().height ?? 0) + 12;
}

function scrollContainerFor(element) {
    let candidate = element?.parentElement ?? null;

    while (candidate) {
        const style = window.getComputedStyle(candidate);
        const canScroll = /(auto|scroll)/.test(style.overflowY);

        if (canScroll && candidate.scrollHeight > candidate.clientHeight) {
            return candidate;
        }

        candidate = candidate.parentElement;
    }

    return document.scrollingElement || document.documentElement;
}

function scrollState(container) {
    return {
        container,
        left: container.scrollLeft,
        top: container.scrollTop,
    };
}

function preferredScrollBehavior(behavior = "auto") {
    if (behavior !== "smooth") {
        return "auto";
    }

    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth";
}

function scrollElementToReviewPosition(row, behavior = "auto") {
    if (!row) {
        return;
    }

    const container = scrollContainerFor(row);
    const rowTop = row.getBoundingClientRect().top;
    const containerTop = container.getBoundingClientRect().top;
    const top = rowTop - containerTop + container.scrollTop - stickyHeaderOffset();

    container.scrollTo({
        top,
        left: container.scrollLeft,
        behavior: preferredScrollBehavior(behavior),
    });
}

function scrollRowIntoView(variantId) {
    afterDomSettles(() => {
        const row = document.querySelector(`[data-shopify-variant-row="${variantId}"]`);

        scrollElementToReviewPosition(row);
    });
}

function preserveAnchorPosition(anchor, fallback) {
    const previousTop = anchor?.getBoundingClientRect().top ?? null;
    const container = fallback.container;

    afterDomSettles(() => {
        if (!anchor || previousTop === null || !anchor.isConnected) {
            container.scrollTo({ left: fallback.left, top: fallback.top });

            return;
        }

        const nextTop = anchor.getBoundingClientRect().top;
        container.scrollBy(0, nextTop - previousTop);
    });
}

function createShopifyVariantMappingTableData() {
    return {
        loadingVariantId: null,
        toggleVariant(variantId, row, isClosing = false) {
            const fallback = scrollState(scrollContainerFor(row));

            if (!isClosing) {
                scrollElementToReviewPosition(row, "smooth");
            }

            this.loadingVariantId = variantId;
            const request = this.$wire.toggleVariant(variantId);

            Promise.resolve(request)
                .then(() => {
                    if (isClosing) {
                        preserveAnchorPosition(row, fallback);

                        return;
                    }

                    scrollRowIntoView(variantId);
                })
                .finally(() => {
                    this.loadingVariantId = null;
                });
        },
        closeVariant(anchor = null) {
            const fallback = scrollState(scrollContainerFor(anchor ?? this.$el));
            const request = this.$wire.closeVariant();

            Promise.resolve(request).then(() => {
                preserveAnchorPosition(anchor, fallback);
            });
        },
        focusWithoutScrolling(element) {
            this.$nextTick(() => {
                element.focus({ preventScroll: true });
            });
        },
    };
}

export function registerShopifyVariantMappingTable(Alpine) {
    Alpine.data("shopifyVariantMappingTable", createShopifyVariantMappingTableData);
}
